import React, { useState, useEffect } from 'react';
import expandIcon from '../assets/images/expandnew.png'; // Adjust the path as necessary
import collapseIcon from '../assets/images/expand.png'; // Adjust the path as necessary

const Product4Legend = ({ legendData, onOpacityChange, riskHazard }) => {
    const [isExpanded, setIsExpanded] = useState(true);
    const [opacityValue, setOpacityValue] = useState(0.8); // Single opacity value for the entire layer

    const toggleContent = () => {
        setIsExpanded(!isExpanded);
    };

    // Handle opacity change for the entire layer
    const handleOpacityChangeInternal = (value) => {
        const newOpacity = parseFloat(value);
        setOpacityValue(newOpacity);
        onOpacityChange(newOpacity); // Notify parent component
    };

    // Reset opacity when riskHazard changes
    useEffect(() => {
        setOpacityValue(0.8); // Default opacity
    }, [riskHazard]);

    const base64ToDataUrl = (base64) => `data:image/png;base64,${base64}`;

    return (
        <>
            <div className="card legendCard two border-0">
                <div className="card-header px-2 py-1 border-0 d-flex mb-0 align-items-center">
                    <div><h3 className="legend-title mb-0 me-2">Legend</h3></div>
                    <div>
                        <button onClick={toggleContent} className="toggle-button px-0" style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
                            <img
                                src={isExpanded ? collapseIcon : expandIcon}
                                alt={isExpanded ? 'Collapse' : 'Expand'}
                                className="toggle-icon"
                            />
                        </button>
                    </div>
                </div>

                {isExpanded && !riskHazard && (
                    <div className="gradient-legend" style={{ padding: "10px" }}>
                        {/* Discrete Color Blocks */}
                        <div className="color-bar" style={{ display: "flex", width: "100%" }}>
                            {legendData.map((item, index) => (
                                <div
                                    key={index}
                                    style={{
                                        backgroundColor: item.color,
                                        width: '40px',
                                        height: "10px",
                                        border: "1px solid black",
                                        borderLeft: index > 0 ? "none" : "1px solid black"
                                    }}
                                ></div>
                            ))}
                        </div>

                        {/* Labels Below the Color Blocks */}
                        <div className="gradient-labels" style={{ display: "flex", justifyContent: "space-between", width: "100%", fontSize: "12px", marginTop: "5px" }}>
                            {legendData.map((item, index) => (
                                <div key={index} style={{ textAlign: "center", flex: "1", fontSize: "10px" }}>
                                    <span style={{ display: "block", color: "black" }}>{item.value == 0 ? item.value : '<=' + item.value}</span>
                                </div>
                            ))}
                        </div>

                        {/* Single Opacity Slider */}
                        <div style={{ margin: '10px 0 10px 10px' }}>
                            <input
                                className="ml-2"
                                type="range"
                                min="0"
                                max="1"
                                step="0.1"
                                value={opacityValue}
                                onChange={(e) => handleOpacityChangeInternal(e.target.value)}
                                style={{
                                    width: '100px',
                                    height: '5px',
                                    borderRadius: '10px',
                                    appearance: 'none',
                                    background: `linear-gradient(to right, #105586 ${opacityValue * 100}%, #ccc 0%)`,
                                }}
                            />
                            <span style={{ fontSize: '10px', fontWeight: '600', marginLeft: '10px' }}>
                                {opacityValue.toFixed(1)}
                            </span>
                        </div>
                    </div>
                )}

                {isExpanded && riskHazard && legendData && (
                    <div className="gradient-legend" style={{ padding: "10px" }}>
                        <img src={base64ToDataUrl(legendData)} alt="Risk Hazard Legend" style={{ height: 'auto', margin: '0px 5px', width: '180px' }} />
                        {/* Single Opacity Slider */}
                        <div style={{ margin: '10px 0 10px 10px' }}>
                            <input
                                className="ml-2"
                                type="range"
                                min="0"
                                max="1"
                                step="0.1"
                                value={opacityValue}
                                onChange={(e) => handleOpacityChangeInternal(e.target.value)}
                                style={{
                                    width: '100px',
                                    height: '5px',
                                    borderRadius: '10px',
                                    appearance: 'none',
                                    background: `linear-gradient(to right, #105586 ${opacityValue * 100}%, #ccc 0%)`,
                                }}
                            />
                            <span style={{ fontSize: '10px', fontWeight: '600', marginLeft: '10px' }}>
                                {opacityValue.toFixed(1)}
                            </span>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default Product4Legend;